import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import CTABanner from "@/components/CTABanner";
import { useSEO } from "@/lib/seo";
import { SERVICES_CONTACT_HERO, SERVICES } from "@/lib/content";

export default function Services() {
  useSEO({
    title: "Services, Bellhouse Law",
    description:
      "Residential Conveyancing, Commercial Property and Business, practical legal services for individuals, businesses and developers.",
  });

  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Practice Areas"
        title="We have deliberately chosen to do a small number of things exceptionally well."
        subtitle="Each practice area is principal-led and built around long-term client relationships."
        image={SERVICES_CONTACT_HERO}
        testId="services-hero"
      />

      <section className="section-pad bg-bone">
        <div className="container-narrow space-y-24">
          {SERVICES.map((s, i) => (
            <div
              key={s.slug}
              className={`grid grid-cols-1 items-center gap-12 md:grid-cols-12 md:gap-16 ${
                i % 2 === 1 ? "md:[direction:rtl]" : ""
              }`}
              data-testid={`services-row-${s.slug}`}
            >
              <div className="md:col-span-6 md:[direction:ltr]">
                <div className="aspect-[5/4] overflow-hidden">
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover" />
                </div>
              </div>
              <div className="md:col-span-6 md:[direction:ltr]">
                <span className="eyebrow">0{i + 1} · Practice Area</span>
                <h2 className="mt-4 text-4xl font-bold leading-tight text-ink md:text-5xl lg:text-[56px]">
                  {s.title}
                </h2>
                <p className="mt-6 text-base leading-relaxed text-ink-soft md:text-lg">
                  {s.overview}
                </p>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`services-detail-${s.slug}`}
                  className="mt-8 inline-flex items-center gap-2 text-[12px] font-medium uppercase tracking-[0.18em] text-sage-700 hover:gap-3"
                >
                  Explore {s.title} <ArrowUpRight className="h-3.5 w-3.5" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
